import React from 'react';
import request from "../../utils/agent";
import { convertCData, toTitleCase } from "../../utils";
import Loader from 'components/Loader';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import './AdminProfile.scss';

export default class AdminProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        cData: { },
        user: { },
        loaded: false,
        editingProfile: false,
        isError: false,
        updateFlag: false,
    };

  }


  componentDidMount() {
      this.getAdminData();
      this.getcData();
  }


  componentDidUpdate() {
      if(this.state.updateFlag === true) {
          this.getcData();
          this.setState({updateFlag: false});
        };
    }


    getAdminData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        user: resp.body.user,
                        loaded: true
                    });
                    resolve(resp.body);
                });

        });
    };

    getcData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({cData: resp.body.user.cdata});
                    resolve(resp.body);
                });
        });
    };


  modalChangePasswordToggle = () => {
    let passwordModal = document.querySelector('#passwordModal');
    passwordModal.classList.toggle('show');
    passwordModal.nextSibling.classList.toggle('show');
  };

  editProfile = () => {
    this.setState({editingProfile: !this.state.editingProfile});
  };

  render() {
      //console.log('admin', this.state.user);
      //console.log('loaded', this.state.loaded);
      //console.log('cdata', this.state.cData);



      const adminSchema = Yup.object().shape({
          email: Yup.string()
              .email('This value should be a valid email.')
              .required('This value is required.'),
          first_name: Yup.string()
              .required('This value is required.'),
          last_name: Yup.string()
              .required('This value is required.')
      });



    return (
      <section >
        <h1>Account Settings</h1>
          {this.state.loaded === true ?
              <div className='admin-profile-container'>
                  <div className='short-desc-hold'>
                      <h5>{this.state.cData.first_name} {this.state.cData.last_name}</h5>
                          <button className='edit-p-button' onClick={this.editProfile}>Edit Profile</button>
                  </div>
                  <div className='details-hold'>
                      {this.state.editingProfile === true ?
                          <Formik
                              initialValues={{
                                  email: this.state.user.email,
                                  first_name: this.state.cData.first_name,
                                  last_name: this.state.cData.last_name,
                              }}
                              validationSchema={adminSchema}
                              enableReinitialize={true}
                              onSubmit={(values, actions) => {
                                  return new Promise((resolve, reject)=> {
                                      request.post('/api/user')
                                          .send({
                                              email: values.email,
                                              first_name: values.first_name,
                                              last_name: values.last_name
                                          })
                                          .then(data => {
                                              actions.setSubmitting(false);
                                              //console.log('finished call');
                                              //console.log(data);
                                          })
                                          .then(resp => {
                                              this.setState({updateFlag: true})
                                          })
                                          .catch(err => {
                                              console.error(err);
                                              this.setState({isError: true});
                                          });
                                  });
                              }}>

                              {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                    handleReset,
                                    resetForm,
                                    dirty
                                }) => (
                                  <Form className='my-f-form' onSubmit={handleSubmit}>
                                      <label className='form-f-label'>Email*</label>
                                      <Field
                                          name='email'
                                          className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                          component='input'
                                          type='text'
                                          placeholder='Email*'
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.email} />
                                      {errors.email && touched.email ?
                                          (<div className='f-field-errors'>{errors.email} </div>) : null
                                      }

                                      <div className='flex--fields--holder'>
                                          <div className='flex-field-container'>
                                              <label className='form-f-label'>First Name*</label>
                                              <div className='flex-with-error-holder'>
                                                  <Field
                                                      name='first_name'
                                                      component='input'
                                                      className=   {errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                      type='text'
                                                      placeholder='First Name*'
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      value={values.first_name}
                                                  />
                                                  {errors.first_name && touched.first_name ? (
                                                      <div className='f-field-errors'>{errors.first_name}</div>) : null
                                                  }
                                              </div>
                                          </div>

                                          <div className='flex-field-container last'>
                                              <label className='form-f-label'>Last Name*</label>
                                              <div className='flex-with-error-holder'>
                                                  <Field
                                                      name='last_name'
                                                      component='input'
                                                      className= {errors.last_name && touched.last_name ?'form-f-field flex-with-error': 'form-f-field'}
                                                      type='text'
                                                      placeholder='Last Name*'
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      value={values.last_name}
                                                  />
                                                  {errors.last_name && touched.last_name ?
                                                      (<div className='f-field-errors'>{errors.last_name}</div>): null
                                                  }
                                              </div>
                                          </div>
                                      </div>

                                      <button className='form-f-button' type="submit" disabled={isSubmitting}>
                                          Save Profile
                                      </button>
                                      {dirty ?
                                          <button className='form-cancel-button' type="cancel" disabled={isSubmitting}
                                                  onClick={handleReset}>
                                              Reset Form
                                          </button> :
                                          <button className='form-cancel-button' type="cancel" disabled={isSubmitting}
                                                  onClick={this.editProfile}>
                                              Cancel
                                          </button>
                                      }

                                  </Form>
                              )}

                          </Formik>:
                          <Formik
                              initialValues={{
                                  email: this.state.user.email,
                                  first_name: this.state.cData.first_name,
                                  last_name: this.state.cData.last_name,
                              }}
                              enableReinitialize={true}>

                              {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                }) => (
                                  <Form className='my-f-form' onSubmit={handleSubmit}>
                                      <label className='form-f-label'>Email*</label>
                                      <Field
                                          component='input'
                                          className='form-f-field'
                                          type='text'
                                          name='email'
                                          value={values.email}
                                          readOnly={true}
                                      />
                                      <div className='flex--fields--holder'>
                                          <div className='flex-field-container'>
                                              <label className='form-f-label'>First Name*</label>
                                              <Field
                                                  component='input'
                                                  className='form-f-field'
                                                  type='text'
                                                  name='first_name'
                                                  value={values.first_name}
                                                  readOnly={true}
                                              />
                                          </div>
                                          <div className='flex-field-container last'>
                                              <label className='form-f-label'>Last Name*</label>
                                              <Field
                                                  component='input'
                                                  className='form-f-field'
                                                  type='text'
                                                  name='last_name'
                                                  value={values.last_name}
                                                  readOnly={true}
                                              />
                                          </div>
                                      </div>
                                  </Form>
                              )}

                          </Formik>

                      }
                  </div>
              </div> :
              <Loader/>
          }
      </section>
    )
  }
};


// WEBPACK FOOTER //
// ./src/routes/AdminProfile/index.js